// material ui icons
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';

// material ui
import { Box } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';

const InfoTooltipIcon = ({ title, color = '#9D9D9C' }) => (
  <Box className="non-printable">
    <Tooltip
      title={title}
      fontSize={22}
      placement="right"
      slotProps={{
        popper: {
          sx: {
            '& .MuiTooltip-tooltip': {
              fontSize: '1em',
            },
          },
        }
      }}
    >
      <InfoRoundedIcon
        fontSize="small"
        sx={{
          color: color || '#9D9D9C',
          ml: 1,
        }}
      />
    </Tooltip>
  </Box>
);

export default InfoTooltipIcon;
